// Design System
import { Message } from 'jl-design-system/components/message/Message';

const ThreeDSecureWarning = () => (
  <Message
    body="To keep you safe, your bank or credit card provider may ask you to confirm the payment by sending you a code by text, email or banking app. They will never ask you to share this code with them or anyone."
    title="Security notice"
    type="warning"
  />
);

export default ThreeDSecureWarning;
